module.exports = __webpack_public_path__ + "img/banana.be5030ca.webp";